/* File: src/components/account/AccountLogoutSection.js */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

// No direct imports of UI components like Button from a '/ui/' directory needed here,
// as the ButtonComponent will be passed via props.

const AccountLogoutSection = ({
    handleLogout,
    // UI Component passed as prop
    ButtonComponent,
}) => {
    // Use the passed-in component.
    const Button = ButtonComponent;

    // Check if essential UI component is passed
    if (!Button) {
        console.error("AccountLogoutSection: Required UI component prop (ButtonComponent) was not provided.");
        return <div className="text-red-500 p-4">Error: UI component for this section is missing.</div>;
    }

    return (
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
            <div className="flex-1">
                <p className="text-sm text-gray-600">Log out of your current session on this device.</p>
            </div>
            <Button
                onClick={handleLogout}
                text="Log Out"
                color="red"
                icon={faSignOutAlt}
                fullWidth={false}
                // No isLoading or disabled state specific to logout button itself usually,
                // as the action is typically quick or leads to navigation.
            />
        </div>
    );
};

export default AccountLogoutSection;